import { createSlice } from '@reduxjs/toolkit';
import type { IUser } from '@/common/interfaces/user.interface';

const initialState = {
  user: {} as IUser,
  memberApprovalInfo: {
    isMemberModalSeen: false,
    memberApprovalStatus: null,
  },
};

export const userSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.user = action.payload;
    },
    setMemberApprovalInfo: (state, action) => {
      state.memberApprovalInfo = action.payload;
    },
  },
});

/** Action creators are generated for each case reducer function */
export const { setUserDetails, setMemberApprovalInfo } = userSlice.actions;

export default userSlice.reducer;
